import { render, staticRenderFns } from "./DiseaseResult.vue?vue&type=template&id=6823b869&scoped=true"
import script from "./DiseaseResult.vue?vue&type=script&lang=js"
export * from "./DiseaseResult.vue?vue&type=script&lang=js"
import style0 from "./DiseaseResult.vue?vue&type=style&index=0&id=6823b869&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6823b869",
  null
  
)

export default component.exports